import { lazy, Suspense, type ComponentProps } from 'react';
import { LoadBoundary } from '../LoadBoundary';
import { Spinner } from '../Loading';
import styles from './placeholder.module.css';

// Leaflet (~40 kB) loads only when a map is actually shown.
const views = () => import('./MapViews');
const MarkersMapLazy = lazy(() => views().then((m) => ({ default: m.MarkersMap })));
const PinPickerMapLazy = lazy(() => views().then((m) => ({ default: m.PinPickerMap })));

export type { MapMarker } from './MapViews';

function Placeholder({ height }: { height: string }) {
  return (
    <div className={styles.placeholder} style={{ height }}>
      <Spinner label="Wczytywanie mapy…" />
    </div>
  );
}

function Unavailable({ height }: { height: string }) {
  return (
    <div className={styles.placeholder} style={{ height }}>
      <p className={styles.message}>Mapa jest teraz niedostępna. Sprawdź połączenie z internetem i odśwież stronę.</p>
    </div>
  );
}

export function MarkersMap(props: ComponentProps<typeof MarkersMapLazy>) {
  return (
    <LoadBoundary fallback={<Unavailable height={props.height} />}>
      <Suspense fallback={<Placeholder height={props.height} />}>
        <MarkersMapLazy {...props} />
      </Suspense>
    </LoadBoundary>
  );
}

export function PinPickerMap(props: ComponentProps<typeof PinPickerMapLazy>) {
  return (
    <LoadBoundary fallback={<Unavailable height={props.height} />}>
      <Suspense fallback={<Placeholder height={props.height} />}>
        <PinPickerMapLazy {...props} />
      </Suspense>
    </LoadBoundary>
  );
}
